(function () {
	'use strict';

	angular.module('widgets.supplychain')
	.config(posToActionNext12MonthsConfig);

	function posToActionNext12MonthsConfig(dashboardProvider) {
		// register widget
		dashboardProvider
			.widget('posToActionNext12Months',
				{
					name: 'POs to Action: Next 12 Months',
					description: 'The total potential savings based on adjusting POs in the next 12 months.',
					thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/big_number_delta_details.png',
					categories: [],
					config: {},
					slideshowView: true,
					isActive: true,
					controller: 'posToActionNext12MonthsChart',
					templateUrl: '/application/f/dashboard/widgets/pos-to-action-next-12-months-chart.html',
					reload: true,
					isDrillDown: false,
					nonRemovable: true
				}
			);
	}
})();
